import Phaser from "phaser";

/**
 * Pure visual representation of a pulsing heart used to indicate a happy cat / balanced budget.
 * No gameplay logic lives here – that will be handled by HeartBehaviour.
 */
export class HeartSprite extends Phaser.GameObjects.Sprite {
  /**
   * Preload the heart spritesheet so it can be used later. Call from a Scene.preload().
   */
  public static preload(scene: Phaser.Scene) {
    // Already queued? Phaser will skip duplicates, but guard anyway.
    if (scene.textures.exists("heart-pulse")) return;

    scene.load.spritesheet("heart-pulse", "/assets/misc/heart.png", {
      frameWidth: 15,
      frameHeight: 15,
      endFrame: 5, // 6 frames total, 0–5
    });
  }

  /**
   * Create the pulsing animation if it doesn\'t exist yet. Call from a Scene.create().
   */
  public static createAnimation(scene: Phaser.Scene) {
    if (scene.anims.exists("heart-pulse")) return;

    scene.anims.create({
      key: "heart-pulse",
      frames: scene.anims.generateFrameNumbers("heart-pulse", {
        start: 0,
        end: 5,
      }),
      frameRate: 6,
      repeat: -1,
    });
  }

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, "heart-pulse");

    scene.add.existing(this);

    // Slightly bigger so it stands out
    this.setScale(2);

    // Play the built-in animation if it exists (loaded during preload)
    if (scene.anims.exists("heart-pulse")) {
      this.play({ key: "heart-pulse", repeat: -1 });
    }
  }
}
